import React from "react"
import { OptionButton } from "./option-button"

export function SectionWidth({ properties, update }) {
  return (
    <div>
      <div className="font-semibold text-gray-600 mb-1">Width</div>
      <div className="flex border rounded mb-2">
        <div className="p-1 flex items-center justify-center flex-grow">
          <OptionButton
            active={properties.maxWidth === 520}
            onClick={() => update({ maxWidth: 520, contentWidth: null })}
          >
            Small
          </OptionButton>
          <OptionButton
            active={properties.maxWidth === 640}
            onClick={() => update({ maxWidth: 640, contentWidth: null })}
          >
            Medium
          </OptionButton>
          <OptionButton
            active={properties.maxWidth === 800}
            onClick={() => update({ maxWidth: 800, contentWidth: null })}
          >
            Large
          </OptionButton>
          <OptionButton
            active={properties.maxWidth === "100%"}
            onClick={() => update({ maxWidth: "100%", contentWidth: 640 })}
          >
            Full
          </OptionButton>
        </div>
      </div>
    </div>
  )
}

{
  /* The content width setting will only show when the secion width is 100% or "full" */
}
export function ContentWidth({ properties, update }) {
  return (
    <>
      {properties.maxWidth === "100%" ? (
        <div>
          <div className="font-semibold text-gray-600 mb-1">Content width</div>
          <div className="flex border rounded mb-2">
            <div className="p-1 flex items-center justify-center flex-grow">
              <OptionButton
                active={properties.contentWidth === 520}
                onClick={() => update({ contentWidth: 520 })}
              >
                Small
              </OptionButton>
              <OptionButton
                active={properties.contentWidth === 640}
                onClick={() => update({ contentWidth: 640 })}
              >
                Medium
              </OptionButton>{" "}
              <OptionButton
                active={properties.contentWidth === 800}
                onClick={() => update({ contentWidth: 800 })}
              >
                Large
              </OptionButton>
              <OptionButton
                active={properties.contentWidth === "100%"}
                onClick={() => update({ contentWidth: "100%" })}
              >
                Full
              </OptionButton>
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}
